import type { StopStatus } from '@stopal/shared/stop-status'

import type { StatusPresetMap } from './types'

// Single-source taxonomy: the value set lives in @stopal/shared (the DB enum
// derives from the same array).
export type { StopStatus } from '@stopal/shared/stop-status'

/**
 * A Stop's status — a truck visit's state. NOT the Order Event status: that
 * taxonomy also carries `confirmed` and `scheduled`, which no stop ever holds.
 * Keyed exhaustively over `StopStatus`, so a new stop status fails compilation
 * here instead of rendering as a raw enum string.
 */
export const stopStatusPresets: StatusPresetMap<StopStatus> = {
  pending: { label: 'Pending', tone: 'neutral' },
  in_progress: { label: 'In Progress', tone: 'progress' },
  completed: { label: 'Completed', tone: 'success' },
  cancelled: { label: 'Cancelled', tone: 'critical' },
}
